import { useCallback } from 'react'

import { useListMembers } from '~/hooks/member/useListMembers'
import { resolveMemberDisplayName } from '~/models/member'

/**
 * eauth member ID (= auth0 subject `auth0|...`) を member 表示名へ解決する
 * resolver を返す hook。 created_by / updated_by 等の監査表示用。
 *
 * 解決できない場合 (一覧の取得前 / 取得失敗 / 退職等で一覧に不在) は undefined を
 * 返し、 **生の member ID は決して返さない** (= auth0 ID の画面露出防止)。
 * 未解決時の fallback 表記 ('—' 等) は caller 側の責務。
 *
 * member 一覧の取得は fail-safe (= 失敗しても error boundary に飛ばさない)。
 * 監査表示はあくまで補助情報なので、 取得不能でも画面自体は描画する。
 */
export function useMemberDisplayName(): (
  memberId: string | undefined,
) => string | undefined {
  const { data } = useListMembers({ failSafe: true })
  const members = data?.members

  return useCallback(
    (memberId: string | undefined): string | undefined =>
      resolveMemberDisplayName(members ?? [], memberId),
    [members],
  )
}
